import { styled } from '@pulse-web-ui/theme';

export const SkeletonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
  flex-grow: 1;
`;
